import { Box, SxProps, Typography } from "@mui/material";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import {
  DETAIL_TAB,
  ProjectDetailContext,
} from "./Interfaces/ProjectDetailInterfaces";
import CoordinateContext, { EDataType } from "./Contexts/CoordinateContext";

type Props = {
  sx?: SxProps;
};

export const CoordinateTXT = (props: Props) => {
  const { t } = useTranslation();
  const { projectDetail, detailTab, isArView, isIosView } =
    useContext(ProjectDetailContext);
  const { currentType, localizedStorageData, storageData } =
    useContext(CoordinateContext);

  return (
    <Box
      sx={{
        position: "absolute",
        backgroundColor: "rgba(0, 0, 0, 0)",
        left: "0px",
        bottom: "0px",
        padding: "4px",
        color: "#808080",
        alignItems: "left",
      }}
    >
      {currentType === EDataType.LOCALIZE &&
      localizedStorageData &&
      localizedStorageData.length > 0 ? (
        <Box sx={{ display: "flex" }}>
          <Box sx={{ userSelect: "none" }}>
            {t("COORDINATE_SYSTEM")} : {t("COORDINATE_SYSTEM_JOBSITE")}(
            {projectDetail?.jobsiteName})
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            display: "grid",
            gap: "4px",
            gridTemplateColumns: "repeat(3, auto)",
            userSelect: "none",
          }}
        >
          {storageData.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <Typography
                  gutterBottom
                  variant="body2"
                  component="div"
                  sx={{ userSelect: "none" }}
                >
                  {item.left}
                </Typography>
                <div>:</div>
                {(isArView || (!isArView && detailTab === DETAIL_TAB.SFM)) &&
                item.right !== "" &&
                item.right !== null &&
                item.right !== undefined ? (
                  <Typography
                    gutterBottom
                    variant="body2"
                    component="div"
                    sx={{ userSelect: "none" }}
                  >
                    {item.right}
                  </Typography>
                ) : (
                  <Box sx={{ userSelect: "none" }}>{t("None")}</Box>
                )}
              </React.Fragment>
            );
          })}
        </Box>
      )}
    </Box>
  );
};
